module.exports = __webpack_public_path__ + "static/media/6.72650c39.jpg";